import { useCallback, useState } from 'react';

export type CreateAction = 'add' | 'add-another';

/**
 * Which of the Add buttons ran the submit. The page shows its busy indicator on that button alone,
 * and only disables the other one.
 */
export const useSubmittingAction = () => {
	const [action, setAction] = useState<CreateAction>();

	const runAs = useCallback(async (next: CreateAction, run: () => Promise<void>) => {
		setAction(next);
		try {
			await run();
		} finally {
			setAction(undefined);
		}
	}, []);

	return { action, runAs };
};
